/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export type IAPI76158ResListItemOtherDataObjDataObj = {};
    
  
    
export type IAPI76158ResListItemOtherDataObjTooltipObj = {};
    
  
    
export type IAPI76158ResListItemOtherDataObjTaskCreatFlowTypeObj = {};
    
  
    
export interface IAPI76158ResListItemOtherDataObj {
  
  /**  */
  messageType?: string;
  
  /** Object */
  data?: IAPI76158ResListItemOtherDataObjDataObj;
  
  /**  */
  chatType?: string;
  
  /** Object */
  tooltip?: IAPI76158ResListItemOtherDataObjTooltipObj;
  
  /** Object */
  taskCreatFlowType?: IAPI76158ResListItemOtherDataObjTaskCreatFlowTypeObj;
  
};
    
  
    
export interface IAPI76158ResListItem {
  
  /**  */
  id?: string;
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** OtherDataResp */
  otherData?: IAPI76158ResListItemOtherDataObj;
  
  /**  */
  sessionToken?: string;
  
  /**  */
  feedBack?: number;
  
  /**  */
  comment?: string;
  
  /**  */
  bizType?: string;
  
};
    
  



export interface API76158Req {
  
  /**  */
  roomId?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API76158Res {
  /** T  */
  list?: IAPI76158ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76158 分页查询聊天记录

export interface IUseGetAPI76158Return {
  /** 分页查询聊天记录: 接口请求状态 */
  isAPI76158Loading: boolean;
  /** 分页查询聊天记录: 接口请求返回数据 */
  dataAPI76158: API76158Res;
  /**  分页查询聊天记录: 接口数据请求方法 */
  fetchAPI76158Data: (inputs: API76158Req, config?: YWRequestConfig) => Promise<API76158Res>;
  /** 分页查询聊天记录: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76158 = ():IUseGetAPI76158Return => {
  let isMount = true;
  const [isAPI76158Loading, setIsAPI76158Loading] = useState(false);
  const [dataAPI76158, setDataAPI76158] = useState<API76158Res>({} as API76158Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/message/page`;

  const fetchAPI76158Data = async (inputs: API76158Req, config?: YWRequestConfig): Promise<API76158Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76158Req>) || {}) as API76158Req;
    
  
    if ( isMount ) {
      setIsAPI76158Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76158Res>(`${basePath}/yoaichat-web/chat/message/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76158(res || {} as API76158Res);
        setIsAPI76158Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76158Loading(false);
      }
      return false as unknown as API76158Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76158Loading,
    dataAPI76158,
    fetchAPI76158Data,
    requestUrl,
  }
}

